export default __webpack_public_path__ + "static/media/wave (1).4e021091.svg";